import { LayoutUnitThickness } from '../../models/basic/layoutunitthickness.model';
import { Alignment, FlexItemAlignment } from '../../models/enums/alignment.enum';
import { BorderStyle } from '../../models/enums/borderstyle.enum';
import { EventActionType } from '../../models/enums/eventactiontype.enum';
import { Orientation } from '../../models/enums/orientation.enum';
import { UnitType } from '../../models/enums/unittype.enum';
import { Layout } from '../../models/layout.model';
import { LayoutBase, StyleBase } from '../../models/layoutbase.model';
import { Border } from '../../models/style/border.model';
import { Color } from '../../models/style/color.model';
import { Font } from '../../models/style/font.model';
import { Gradient } from '../../models/style/gradient.model';
import { DataSwitchSettings, DataSwitchSettingsData } from '../../workflow/modules/dataswitch/dataswitch.settings';
import { DefineMultiValuesSettingsData } from '../../workflow/modules/definevalue/define.multi.values.settings';
import { DefineValueSettings } from '../../workflow/modules/definevalue/define.value.settings';
import { ExecuteWorkflowData } from '../../workflow/modules/executeWorkflow/executeWorkflow.settings';
import { SetControlPropertiesSettings, SetControlPropertiesSettingsData } from '../../workflow/modules/layout/elemProperty/set.control.properties.settings';
import { GetMultiElemValueSettings, GetMultiElemValueSettingsData } from '../../workflow/modules/layout/elemValue/get.multi.elem.value.settings';
import { RemoveMultiStyleSettings, RemoveMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/remove.multi.style.settings';
import { SetMultiStyleSettings, SetMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/set.multi.style.settings';
import { UpdatePasswordSettings, UpdatePasswordSettingsData } from '../../workflow/modules/login/update.password.settings';
import { OpenURLSettings, OpenURLSettingsData } from '../../workflow/modules/navigation/openURL.settings';
import { ReadMultiPropertySettings, ReadMultiPropertySettingsData } from '../../workflow/modules/readProperty/read.multi.property.settings';
import { SleepSettings, SleepSettingsData } from '../../workflow/modules/sleep/sleep.settings';
import { SetWorkflowStatusData, SetWorkflowStatusSettings } from '../../workflow/modules/wfStatus/setWFStatus.settings';
import { ForgotPWLayoutHelper } from './forgot.pw.layout.helper';
import { LoginLayoutHelper } from './login.layout.helper';

export class ResetPWLayoutHelper {
    static GetLayout(): Layout {
        //#region Layout
        const l = new Layout();
        l.Visible = true;
        l.Name = 'Reset';
        l.BackgroundColor = Gradient.Solid(Color.FromHex('#F9FAFB'));
        l['ElementType'] = 'grid';

        const outerCol = new LayoutBase();
        outerCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['ColumnDefinitions'] = [outerCol];

        const outerRow = new LayoutBase();
        outerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['RowDefinitions'] = [outerRow];

        const loading = LoginLayoutHelper.GetLayoutElement('Loading', 'loading', false);
        l.Elements.push(loading);

        const innerGrid = LoginLayoutHelper.GetLayoutElement('InnerGrid', 'grid');

        innerGrid.Width = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        innerGrid.Height = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        innerGrid.HorizontalContentAlignment = Alignment.Center;
        innerGrid.VerticalContentAlignment = Alignment.Center;
        innerGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#FFFFFF'));
        innerGrid.Border = new Border();
        innerGrid['UseBorder'] = true;
        LoginLayoutHelper.SetBorderRadius(innerGrid.Border, 12);
        innerGrid.Font = new Font();
        innerGrid.Font.FontColor = Color.FromHex('#334155');
        innerGrid.Padding = new LayoutUnitThickness();
        innerGrid.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid['UseDecorationsOnLayout'] = true;
        innerGrid['DropShadow'] = true;
        innerGrid['BoxShadow'] = [{
            "Color": "#000000",
            "ShiftRight": 0,
            "ShiftDown": 3,
            "Blur": 16,
            "Spread": 0,
            "Opacity": 0.16
        }];

        const innerFirstCol = new LayoutBase();
        innerFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 370);
        innerGrid['ColumnDefinitions'] = [innerFirstCol];

        let rowIndex = 1;

        const headerFlex = LoginLayoutHelper.GetLayoutElement('HeaderFlex', 'flex');
        headerFlex.Row = rowIndex++;
        headerFlex['Orientation'] = Orientation.Horizontal;
        headerFlex['FlexAlignItems'] = FlexItemAlignment.center;
        headerFlex.Margin = new LayoutUnitThickness();
        headerFlex.Margin.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 12);

        const resetIcon = LoginLayoutHelper.GetLayoutElement('ResetIcon', 'icon');
        resetIcon['Icon'] = 'lock2';
        resetIcon['IconHeight'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 17);
        resetIcon['IconWidth'] = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 17);
        resetIcon.Margin = new LayoutUnitThickness();
        resetIcon.Margin.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        headerFlex.Elements.push(resetIcon);

        const resetHeader = LoginLayoutHelper.GetLayoutElement('ResetHeader', 'textblock');
        resetHeader.Caption = '@@SetNewPW';
        resetHeader.Font = new Font();
        resetHeader.Font.FontSize = 14;
        headerFlex.Elements.push(resetHeader);

        innerGrid.Elements.push(headerFlex);

        const resetDesc = LoginLayoutHelper.GetLayoutElement('ResetDescription', 'textblock');
        resetDesc.Row = rowIndex++;
        resetDesc.Caption = '@@SetNewPWInfo';
        resetDesc.Font = new Font();
        resetDesc.Font.FontSize = 11;
        resetDesc.Padding = new LayoutUnitThickness();
        resetDesc.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);
        innerGrid.Elements.push(resetDesc);

        const newPWGrid = LoginLayoutHelper.GetLayoutElement('NewPWGrid', 'grid');
        newPWGrid.Row = rowIndex++;
        const newPWGridCol = new LayoutBase();
        newPWGridCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        newPWGrid['ColumnDefinitions'] = [newPWGridCol];
        const newPWGridFirstRow = new LayoutBase();
        newPWGridFirstRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const newPWGridSecondRow = new LayoutBase();
        newPWGridSecondRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        newPWGrid['RowDefinitions'] = [newPWGridFirstRow, newPWGridSecondRow];

        const newPWHeader = LoginLayoutHelper.GetLayoutElement('NewPWHeader', 'textblock');
        newPWHeader.Caption = '@@NewPW';
        newPWHeader.Font = new Font();
        newPWHeader.Font.FontSize = 8;
        newPWHeader.Padding = new LayoutUnitThickness();
        newPWHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        newPWGrid.Elements.push(newPWHeader);

        const newPWTB = LoginLayoutHelper.GetLayoutElement('NewPWTB', 'textbox');
        newPWTB.Row = 2;
        newPWTB.Editable = true;
        newPWTB['InputType'] = 'password';
        newPWTB['ShowPassword'] = true;
        newPWGrid.Elements.push(newPWTB);

        innerGrid.Elements.push(newPWGrid);

        const repeatPWGrid = LoginLayoutHelper.GetLayoutElement('NewPWGrid', 'grid');
        repeatPWGrid.Row = rowIndex++;
        const repeatPWGridCol = new LayoutBase();
        repeatPWGridCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        repeatPWGrid['ColumnDefinitions'] = [repeatPWGridCol];
        const repeatPWGridFirstRow = new LayoutBase();
        repeatPWGridFirstRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const repeatPWGridSecondRow = new LayoutBase();
        repeatPWGridSecondRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        repeatPWGrid['RowDefinitions'] = [repeatPWGridFirstRow, repeatPWGridSecondRow];

        const repeatPWHeader = LoginLayoutHelper.GetLayoutElement('RepeatPWHeader', 'textblock');
        repeatPWHeader.Caption = '@@ConfirmNewPW';
        repeatPWHeader.Font = new Font();
        repeatPWHeader.Font.FontSize = 8;
        repeatPWHeader.Padding = new LayoutUnitThickness();
        repeatPWHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        repeatPWGrid.Elements.push(repeatPWHeader);

        const repeatPWTB = LoginLayoutHelper.GetLayoutElement('RepeatPWTB', 'textbox');
        repeatPWTB.Row = 2;
        repeatPWTB.Editable = true;
        repeatPWTB['InputType'] = 'password';
        repeatPWTB['ShowPassword'] = true;
        repeatPWGrid.Elements.push(repeatPWTB);

        innerGrid.Elements.push(repeatPWGrid);

        const successGrid = LoginLayoutHelper.GetLayoutElement('SuccessGrid', 'grid', false);
        successGrid.Row = rowIndex;
        const successGridFirstCol = new LayoutBase();
        successGridFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const successGridSecondCol = new LayoutBase();
        successGridSecondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        successGrid['ColumnDefinitions'] = [successGridFirstCol, successGridSecondCol];
        const successGridRow = new LayoutBase();
        successGridRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        successGrid['RowDefinitions'] = [successGridRow];
        LoginLayoutHelper.SetBorder(successGrid, 1, BorderStyle.Solid, '#bbf7d0');
        LoginLayoutHelper.SetBorderRadius(successGrid.Border, 6);
        successGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#f0fdf4f2'));
        successGrid.Padding = new LayoutUnitThickness();
        successGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const successHeader = LoginLayoutHelper.GetLayoutElement('SuccessHeader', 'textblock');
        successHeader.Column = 2;
        successHeader.Caption = '@@PWResetSuccess';
        successHeader.Font = new Font();
        successHeader.Font.FontColor = Color.FromHex('#16a34a');
        successHeader.Font.FontSize = 11;
        successHeader.Padding = new LayoutUnitThickness();
        successHeader.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        successHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        successHeader.VerticalTextAlignment = Alignment.Center;
        successGrid.Elements.push(successHeader);

        const successIcon = LoginLayoutHelper.GetLayoutElement('SuccessIcon', 'icon');
        successIcon['Icon'] = 'checkbox';
        successIcon.Font = new Font();
        successIcon.Font.FontColor = Color.FromHex('#16a34a');
        successIcon.Padding = new LayoutUnitThickness();
        successIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        successIcon.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        successIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        successGrid.Elements.push(successIcon);

        innerGrid.Elements.push(successGrid);


        const errorGrid = LoginLayoutHelper.GetLayoutElement('ErrorGrid', 'grid', false);
        errorGrid.Row = rowIndex++;
        const errorGridFirstCol = new LayoutBase();
        errorGridFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const errorGridSecondCol = new LayoutBase();
        errorGridSecondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        errorGrid['ColumnDefinitions'] = [errorGridFirstCol, errorGridSecondCol];
        const errorGridRow = new LayoutBase();
        errorGridRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        errorGrid['RowDefinitions'] = [errorGridRow];
        LoginLayoutHelper.SetBorder(errorGrid, 1, BorderStyle.Solid, '#fecaca');
        LoginLayoutHelper.SetBorderRadius(errorGrid.Border, 6);
        errorGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#fef2f2f2'));
        errorGrid.Padding = new LayoutUnitThickness();
        errorGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const errorHeader = LoginLayoutHelper.GetLayoutElement('ErrorHeader', 'textblock');
        errorHeader.Column = 2;
        //errorHeader.Caption = '@@PWResetSuccess'; ???
        errorHeader.Font = new Font();
        errorHeader.Font.FontColor = Color.FromHex('#dc2626');
        errorHeader.Font.FontSize = 11;
        errorHeader.Padding = new LayoutUnitThickness();
        errorHeader.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorHeader.VerticalTextAlignment = Alignment.Center;
        errorGrid.Elements.push(errorHeader);

        const errorIcon = LoginLayoutHelper.GetLayoutElement('ErrorIcon', 'icon');
        errorIcon['Icon'] = 'cancel';
        errorIcon.Font = new Font();
        errorIcon.Font.FontColor = Color.FromHex('#dc2626');
        errorIcon.Padding = new LayoutUnitThickness();
        errorIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        errorIcon.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        errorIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        errorGrid.Elements.push(errorIcon);

        innerGrid.Elements.push(errorGrid);

        const resetButton = LoginLayoutHelper.GetLayoutElement('ResetButton', 'button');
        resetButton.Editable = true;
        resetButton.Row = rowIndex;
        resetButton.Caption = '@@UpdatePW';
        resetButton['ButtonType'] = 'mat-button';
        resetButton.BackgroundColor = Gradient.Solid(Color.FromHex('#2bee82'));
        resetButton.Font = new Font();
        resetButton.Font.FontColor = Color.FromHex('#113342');
        innerGrid.Elements.push(resetButton);

        const innerRows = [];
        for (let i = 0; i < rowIndex; i++) {
            const innerRow = new LayoutBase();
            innerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
            innerRows.push(innerRow);
        }
        innerGrid['RowDefinitions'] = innerRows;

        l.Elements.push(innerGrid);
        //#endregion

        //#region Workflows
        let wfID = 0;

        //#region UpdatePW
        const updateStartID = wfID++;
        const updatePW = LoginLayoutHelper.GetWFDescription('UpdatePW',
            '56f80036-8400-6509-7eb0-6592ae28f304', updateStartID);

        const loadingStyle = new StyleBase();
        loadingStyle.Visible = true;
        const loadingSetStyle = new SetMultiStyleSettingsData();
        loadingSetStyle.Styles.push({
            Elements: [{ ElemName: loading.Name }],
            Layout: loadingStyle,
            StyleRef: null
        });
        const loadingSetStyleModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 28, 119);
        loadingSetStyleModule.Module = SetMultiStyleSettings.ModuleID;
        loadingSetStyleModule.Settings = loadingSetStyle;
        updatePW.Data.Modules.push(loadingSetStyleModule);

        const setErrorCaptionData = new SetControlPropertiesSettingsData();
        setErrorCaptionData.Controls.push({
            ControlName: errorHeader.Name,
            Properties: [{
                Formula: 'translate("@@PWResetError")',
                PropertyName: 'Caption'
            }]
        });
        const setErrorCaptionModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 18, 182);
        setErrorCaptionModule.Module = SetControlPropertiesSettings.ModuleID;
        setErrorCaptionModule.Settings = setErrorCaptionData;
        updatePW.Data.Modules.push(setErrorCaptionModule);

        const resetResultStylesData = new RemoveMultiStyleSettingsData();
        resetResultStylesData.Elements.push({ ElemName: successGrid.Name });
        resetResultStylesData.Elements.push({ ElemName: errorGrid.Name });
        const resetResultStylesModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 17, 257);
        resetResultStylesModule.Module = RemoveMultiStyleSettings.ModuleID;
        resetResultStylesModule.Settings = resetResultStylesData;
        updatePW.Data.Modules.push(resetResultStylesModule);

        const readPasswordsData = new GetMultiElemValueSettingsData();
        readPasswordsData.Elements.push({
            ElemName: newPWTB.Name,
            UseForState: false,
            StatusKey: 'password'
        });
        readPasswordsData.Elements.push({
            ElemName: repeatPWTB.Name,
            UseForState: false,
            StatusKey: 'pwRepeat'
        });
        const readPasswordsModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 19, 340);
        readPasswordsModule.Module = GetMultiElemValueSettings.ModuleID;
        readPasswordsModule.Settings = readPasswordsData;
        updatePW.Data.Modules.push(readPasswordsModule);

        const dataSwitchProps = new DataSwitchSettingsData();
        dataSwitchProps.Conditions.push({
            Formula: 'Or(IsNull(password); password="")',
            Name: 'isNull'
        });
        dataSwitchProps.Conditions.push({
            Formula: 'password <> pwRepeat',
            Name: 'notEqual'
        });
        const dataSwitchModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 261, 171);
        dataSwitchModule.Module = DataSwitchSettings.ModuleID;
        dataSwitchModule.Settings = dataSwitchProps;
        updatePW.Data.Modules.push(dataSwitchModule);

        const updatePWData = new UpdatePasswordSettingsData();
        updatePWData.NewPassword = 'password';
        const updatePWModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 212, 325);
        updatePWModule.Module = UpdatePasswordSettings.ModuleID;
        updatePWModule.Settings = updatePWData;
        updatePW.Data.Modules.push(updatePWModule);

        const showSuccessStyle = new StyleBase();
        showSuccessStyle.Visible = true;
        const showSuccessData = new SetMultiStyleSettingsData();
        showSuccessData.Styles.push({
            Elements: [{ ElemName: successGrid.Name }],
            Layout: showSuccessStyle,
            StyleRef: null
        });
        const showSuccessModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 107, 448);
        showSuccessModule.Module = SetMultiStyleSettings.ModuleID;
        showSuccessModule.Settings = showSuccessData;
        updatePW.Data.Modules.push(showSuccessModule);

        const delayData = new SleepSettingsData();
        delayData.SleepTime = 5000;
        const delayModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 74, 553);
        delayModule.Module = SleepSettings.ModuleID;
        delayModule.Settings = delayData;
        updatePW.Data.Modules.push(delayModule);

        const goBackMultiValue = new DefineMultiValuesSettingsData();
        goBackMultiValue.Values.push({
            Formula: 'GenerateNull()',
            StatusKey: 'url',
            UseForState: false
        });
        const goBackMultiValueModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 67, 645);
        goBackMultiValueModule.Module = DefineValueSettings.MultiModuleID;
        goBackMultiValueModule.Settings = goBackMultiValue;
        updatePW.Data.Modules.push(goBackMultiValueModule);

        const openURLData = new OpenURLSettingsData();
        openURLData.Internal = true;
        openURLData.ReadURLFromStatus = true;
        openURLData.OpenInNewWindow = false;
        openURLData.URL = 'url';
        const openURLModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 81, 743);
        openURLModule.Module = OpenURLSettings.ModuleID;
        openURLModule.Settings = openURLData;
        updatePW.Data.Modules.push(openURLModule);

        const setErrorState = new SetWorkflowStatusData();
        setErrorState.KeepActualParam = true;
        setErrorState.StatusKey = 'errorText';
        const setErrorModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 368, 431);
        setErrorModule.Module = SetWorkflowStatusSettings.ModuleID;
        setErrorModule.Settings = setErrorState;
        updatePW.Data.Modules.push(setErrorModule);

        const setErrorCaptionData2 = new SetControlPropertiesSettingsData();
        setErrorCaptionData2.Controls.push({
            ControlName: errorHeader.Name,
            Properties: [{
                Formula: 'errorText',
                PropertyName: 'Caption'
            }]
        });
        const setErrorCaptionModule2 = ForgotPWLayoutHelper.GetWFModule(wfID++, 397, 516);
        setErrorCaptionModule2.Module = SetControlPropertiesSettings.ModuleID;
        setErrorCaptionModule2.Settings = setErrorCaptionData2;
        updatePW.Data.Modules.push(setErrorCaptionModule2);

        const showErrorStyle = new StyleBase();
        showErrorStyle.Visible = true;
        const showErrorData = new SetMultiStyleSettingsData();
        showErrorData.Styles.push({
            Elements: [{ ElemName: errorGrid.Name }],
            Layout: showErrorStyle,
            StyleRef: null
        });
        const showErrorModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 389, 588);
        showErrorModule.Module = SetMultiStyleSettings.ModuleID;
        showErrorModule.Settings = showErrorData;
        updatePW.Data.Modules.push(showErrorModule);

        const defineErrorData = new DefineMultiValuesSettingsData();
        defineErrorData.Values.push({
            Formula: 'translate("@@EmptyPW")',
            StatusKey: 'errorText',
            UseForState: false
        });
        const defineErrorModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 488, 67);
        defineErrorModule.Module = DefineValueSettings.MultiModuleID;
        defineErrorModule.Settings = defineErrorData;
        updatePW.Data.Modules.push(defineErrorModule);

        const defineErrorData2 = new DefineMultiValuesSettingsData();
        defineErrorData2.Values.push({
            Formula: 'translate("@@PWNoMatch")',
            StatusKey: 'errorText',
            UseForState: false
        });
        const defineErrorModule2 = ForgotPWLayoutHelper.GetWFModule(wfID++, 629, 283);
        defineErrorModule2.Module = DefineValueSettings.MultiModuleID;
        defineErrorModule2.Settings = defineErrorData2;
        updatePW.Data.Modules.push(defineErrorModule2);

        const hideLoadingData = new RemoveMultiStyleSettingsData();
        hideLoadingData.Elements.push({ ElemName: loading.Name });
        const hideLoadingModule = ForgotPWLayoutHelper.GetWFModule(wfID++, 534, 696);
        hideLoadingModule.Module = RemoveMultiStyleSettings.ModuleID;
        hideLoadingModule.Settings = hideLoadingData;
        updatePW.Data.Modules.push(hideLoadingModule);

        updatePW.Data.Connectors.push({
            ExitModule: updateStartID,
            EntryModule: loadingSetStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: loadingSetStyleModule.ID,
            EntryModule: setErrorCaptionModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: setErrorCaptionModule.ID,
            EntryModule: resetResultStylesModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: resetResultStylesModule.ID,
            EntryModule: readPasswordsModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: readPasswordsModule.ID,
            EntryModule: dataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: updatePWModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: defineErrorModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        updatePW.Data.Connectors.push({
            ExitModule: defineErrorModule.ID,
            EntryModule: setErrorCaptionModule2.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: defineErrorModule2.ID,
            EntryOption: 0,
            ExitOption: 2
        });
        updatePW.Data.Connectors.push({
            ExitModule: defineErrorModule2.ID,
            EntryModule: setErrorCaptionModule2.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: updatePWModule.ID,
            EntryModule: showSuccessModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: showSuccessModule.ID,
            EntryModule: delayModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: delayModule.ID,
            EntryModule: goBackMultiValueModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: goBackMultiValueModule.ID,
            EntryModule: openURLModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: openURLModule.ID,
            EntryModule: hideLoadingModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: updatePWModule.ID,
            EntryModule: setErrorModule.ID,
            EntryOption: 0,
            ExitOption: -1
        });
        updatePW.Data.Connectors.push({
            ExitModule: setErrorModule.ID,
            EntryModule: setErrorCaptionModule2.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: setErrorCaptionModule2.ID,
            EntryModule: showErrorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        updatePW.Data.Connectors.push({
            ExitModule: showErrorModule.ID,
            EntryModule: hideLoadingModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        l.Workflows.push(updatePW);

        resetButton.Events.push({
            EventID: 'click',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: updatePW.ID
                }
            ]
        });
        //#endregion

        wfID = 0;
        //#region OnEnter
        const keyDownStartID = wfID++;
        const keyDownWF = LoginLayoutHelper.GetWFDescription('OnEnter',
            '937cdff9-71c9-4873-910d-b6ac1e2fd55d', keyDownStartID);

        const readProps = new ReadMultiPropertySettingsData();
        readProps.Properties.push({
            PropName: 'key',
            StatusKey: 'key',
            UseForState: false
        });
        const readPropsModule = LoginLayoutHelper.GetWFModule(wfID++);
        readPropsModule.Module = ReadMultiPropertySettings.ModuleID;
        readPropsModule.Settings = readProps;
        keyDownWF.Data.Modules.push(readPropsModule);

        const dataSwitch = new DataSwitchSettingsData();
        dataSwitch.Conditions.push({
            Name: 'Enter',
            Formula: 'key="Enter"'
        });
        const enterDataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        enterDataSwitchModule.Module = 'dataswitchWFModule';
        enterDataSwitchModule.Settings = dataSwitch;
        keyDownWF.Data.Modules.push(enterDataSwitchModule);

        const execWF = new ExecuteWorkflowData();
        execWF.WorkflowID = updatePW.ID;
        const execWFModule = LoginLayoutHelper.GetWFModule(wfID++);
        execWFModule.Module = 'execWFModule';
        execWFModule.Settings = execWF;
        keyDownWF.Data.Modules.push(execWFModule);

        const keyDownRemoveStyle = new RemoveMultiStyleSettingsData();
        keyDownRemoveStyle.Elements.push({ ElemName: errorGrid.Name });
        const keyDownRemoveStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        keyDownRemoveStyleModule.Module = RemoveMultiStyleSettings.ModuleID;
        keyDownRemoveStyleModule.Settings = keyDownRemoveStyle;
        keyDownWF.Data.Modules.push(keyDownRemoveStyleModule);

        keyDownWF.Data.Connectors.push({
            ExitModule: keyDownStartID,
            EntryModule: readPropsModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: readPropsModule.ID,
            EntryModule: enterDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: enterDataSwitchModule.ID,
            EntryModule: execWFModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: enterDataSwitchModule.ID,
            EntryModule: keyDownRemoveStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        newPWTB.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        repeatPWTB.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        l.Workflows.push(keyDownWF);
        //#endregion

        //#endregion
        return l;
    }
}